export default "__VITE_ASSET__3c58d935__"